// eslint-disable-next-line no-unused-vars
import _ from 'lodash';
import store from '@/store';

// NOTE: Do not use: includes full lodash lib
// ==========================================
// import resolveConfig from 'tailwindcss/resolveConfig';
import tailwind from '@/../tailwind.config.js';

import SetupApi from '@/store/api/setup';
import { default as router, resetRouter } from '@/router';
import { get } from '@/helpers';
import CategoryPost from '@/views/CategoryPost';

import PasswordResetForm from '@/extensions/restricted-area/views/PasswordResetForm';
import EmailVerificationForm from '@/extensions/restricted-area/views/EmailVerificationForm';

// initial state
const state = {
    initialised: false,
    loaded: false,
    error: false,
    CMS: {},
    ui: {
        sidebar: false // sidebar visibility
    }
};

const getters = {
    initialised: state => state.initialised,
    loaded: state => state.loaded,
    error: state => state.error,
    CMS: state => state.CMS,
    config: state => state.CMS.config,
    menus: state => state.CMS.menus,
    messages: state => state.messages,
    sidebar: state => state.ui.sidebar,

    tailwind: () => tailwind,

    logo: state => {
        let logo = {};
        if (state.CMS.images && state.CMS.images.length > 0) {
            logo = state.CMS.images.find(image => image.type === 'cms-logo');
        }
        return logo;
    },

    googleRecaptchaSiteKey: state => {
        const apiKeys = get(state.CMS, 'apiKeys') || [];
        const apiKey = apiKeys.find(apiKey => apiKey.key === 'google-recaptcha-v3');

        let googleRecaptchaSiteKey;
        if (apiKey) {
            googleRecaptchaSiteKey = apiKey.public;
        }
        return googleRecaptchaSiteKey;
    },

    mapBoxToken: state => {
        const apiKeys = get(state.CMS, 'apiKeys') || [];
        const apiKey = apiKeys.find(apiKey => apiKey.key === 'mapbox');

        let mapboxKey;
        if (apiKey) mapboxKey = apiKey.public;
        return mapboxKey;
    }
};

const actions = {
    async initialise({ commit, dispatch, getters }, { base_url }) {
        let actions = [];
        const fetchCms = SetupApi.fetchCms(base_url)
            .then(cms => {
                if (cms) {
                    commit('initialise', cms);
                    // commit('mapRouter');
                } else {
                    commit('setError', { code: 404, message: 'Not Found!' });
                }
            })
            .catch(error => commit('fetchFailed', error));

        actions.push(fetchCms);
        if (getters['auth/isAuthenticated']) {
            const fetchAuthenticatedMember = dispatch('auth/fetchAuthenticatedMember');
            actions.push(fetchAuthenticatedMember);
        } else {
            commit('shop/setCartInitialised', false, { root: true });
            dispatch('shop/initCart', null, { root: true });
        }

        return Promise.all(actions).then(() => {
            commit('mapRouter');
        });
    }
};

const mutations = {
    initialise(state, cms) {
        state.CMS = cms;
        state.initialised = true;
    },
    loaded(state, value) {
        if (state.initialised && value) state.loaded = value;
        else state.loaded = false;
    },
    updateSidebarVisibility(state, value) {
        state.ui.sidebar = value;
    },
    mapRouter(state) {
        let loadingRoutes = [];

        const staticRoutes = [
            {
                path: '/resetpassword/:email/:token',
                name: 'Passwort zurücksetzen',
                component: PasswordResetForm,
                meta: {
                    icon: null,
                    title: state.CMS.name ? `${state.CMS.name} - Passwort zurücksetzen` : 'Passwort zurücksetzen',
                    skipMiddleware: true
                }
            },
            {
                path: '/verify/:id/:hash/:expires/:signature',
                name: 'Account bestätigen',
                component: EmailVerificationForm,
                meta: {
                    icon: null,
                    title: state.CMS.name ? `${state.CMS.name} - Account bestätigen` : 'Account bestätigen',
                    skipMiddleware: true
                }
            },
            {
                path: '/aktuelles/:key/:src?',
                name: 'aktuelles',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Aktuelles',
                    category: {
                        key: 'aktuelles'
                    }
                }
            },
            {
                path: '/modernisierung-und-kalibrierung/:key/:src?',
                name: 'modernisierung-und-kalibrierung',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Modernisierung und Kalibrierung',
                    category: {
                        key: 'modernisierung-und-kalibrierung'
                    }
                }
            },
            {
                path: '/portable-werkstoffpruefmaschinen/:key/:src?',
                name: 'portable-werkstoffpruefmaschinen',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Portable Werkstoffprüfmaschinen',
                    category: {
                        key: 'portable-werkstoffpruefmaschinen'
                    }
                }
            },
            {
                path: '/generalueberholte-werkstoffpruefmaschinen/:key/:src?',
                name: 'generalueberholte-werkstoffpruefmaschinen',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Generalüberholte Werkstoffprüfmaschinen',
                    category: {
                        key: 'generalueberholte-werkstoffpruefmaschinen'
                    }
                }
            },
            {
                path: '/blog/:key/:src?',
                name: 'blog',
                // component: () => import('@/views/CategoryPost.vue'),
                meta: {
                    icon: null,
                    title: state.CMS.name ? `${state.CMS.name} - Blog` : 'Blog',
                    category: {
                        key: 'blog'
                    }
                }
            },
            {
                path: '*',
                name: 'Page Not Found',
                component: () => import('@/views/PageNotFound.vue'),
                meta: {
                    icon: null,
                    title: state.CMS.name ? `${state.CMS.name} - Page Not Found` : 'Page Not Found',
                    skipMiddleware: true
                }
            }
            // add static category routes
        ];
        const isAuthenticated = store.getters['auth/isAuthenticated'];

        if (state.CMS.menus && state.CMS.menus.length) {
            const nodeRoutes = data => {
                let routes = [];
                let items = data.items;

                items.forEach((item, index) => {
                    if (item.disabled) return true;

                    // if (item.restriction === 'members' && !isAuthenticated) return true;
                    // else if (item.restriction === 'guests' && isAuthenticated) return true;

                    if (item.restriction === 'guests' && isAuthenticated) return true;

                    if (item.disabled) return true;

                    // let children = null;
                    // if (item.children) {
                    //   children = nodeRoutes({ items: item.children });
                    // }

                    if (item.page && item.page.view === 'Folder') return true;

                    let component, view;
                    if (item.restriction === 'members' && !isAuthenticated) {
                        component = () => import(`@/extensions/restricted-area/views/Unauthorized.vue`);
                        view = item.page.view;
                    } else if (item.page && item.page.view) {
                        component = () => import(`@/views/${item.page.view}.vue`);
                        if (item.page.extension && item.page.extension.key) {
                            component = () =>
                                import(`@/extensions/${item.page.extension.key}/views/${item.page.view}.vue`);
                        }
                        view = item.page.view;
                    }

                    const meta = {
                        rootIndex: index,
                        icon: item.icon,
                        title: state.CMS.name ? `${state.CMS.name} - ${item.title}` : item.title,
                        pageID: get(item.page, 'id'),
                        menuItemID: item.id
                    };

                    switch (view) {
                        case 'Logout':
                            return true;
                        case 'UserForm': {
                            const node = {
                                name: 'user-form-redirect',
                                path: item.path,
                                redirect: `${item.path}/account`, // TODO: bestellungen
                                component,
                                children: [
                                    {
                                        name: 'user-form-orders',
                                        path: 'bestellungen',
                                        component: () =>
                                            import(`@/extensions/restricted-area/components/UserForm/Orders.vue`),
                                        meta: { ...meta, skipMiddleware: true }
                                    },
                                    {
                                        name: 'user-form-returns',
                                        path: 'ruecksendungen',
                                        component: () =>
                                            import(`@/extensions/restricted-area/components/UserForm/Returns.vue`),
                                        meta: { ...meta, skipMiddleware: true }
                                    },
                                    {
                                        name: 'user-form-account',
                                        path: 'account',
                                        component: () =>
                                            import(`@/extensions/restricted-area/components/UserForm/Account.vue`),
                                        meta: { ...meta, skipMiddleware: true }
                                    },
                                    {
                                        name: 'user-form-addresses',
                                        path: 'adressen',
                                        component: () =>
                                            import(`@/extensions/restricted-area/components/UserForm/Addresses.vue`),
                                        meta: { ...meta, skipMiddleware: true }
                                    }
                                ]
                            };
                            routes.push(node);
                            break;
                        }
                        case 'Redirect': {
                            const type = get(item.page, 'hyperlink.type');
                            const redirect = get(item.page, 'hyperlink.menuItem.path');
                            if (type === 'internal' && redirect) {
                                const node = {
                                    name: item.id, // prevent duplicate named routes warning
                                    path: item.path,
                                    redirect,
                                    meta
                                };
                                routes.push(node);
                            }
                            break;
                        }
                        default: {
                            const node = {
                                name: item.id, // prevent duplicate named routes warning
                                path: item.path,
                                component,
                                meta
                            };
                            routes.push(node);
                        }
                    }
                });

                return routes;
            };

            let dynamicRoutes = [];
            state.CMS.menus.forEach(menu => {
                nodeRoutes({ items: menu.menuItems }).forEach(item => dynamicRoutes.push(item));
            });

            dynamicRoutes.forEach(route => {
                loadingRoutes.push(route);
            });
        }

        staticRoutes.forEach(route => {
            loadingRoutes.push(route);
        });

        resetRouter();
        loadingRoutes.forEach(route => router.addRoute(route));
        // router.addRoutes(loadingRoutes);
    },
    fetchFailed(state, error) {
        console.error(error);
        state.error = error;
    },
    setError(state, error) {
        state.error = error;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
